import { useLayoutEffect, useRef, useState } from 'react';

import { WidgetItem, WidgetProviderData } from 'context/widgetProvider/types';

const useCheckDataIsEmpty = (data: WidgetProviderData<WidgetItem>) => {
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  const isPrevLoadFirst = useRef(data.isLoading);

  useLayoutEffect(() => {
    // after first loading items is empty or after application navigation(items received from cache)
    // in Rentals rail case client has totalCount(it's adult), but items = 0
    const isDataShouldBeEmpty =
      !!data.error ||
      (!data.isLoading && !data.items.length && (isPrevLoadFirst.current || data.totalCount)) ||
      (!data.isLoading && !data.items.length && !isPrevLoadFirst.current && !data.totalCount);

    if (isDataShouldBeEmpty) {
      isPrevLoadFirst.current = false;
      setIsDataEmpty(true);
    }
  }, [data.isLoading]);

  return isDataEmpty;
};

export { useCheckDataIsEmpty };
